import { parseMeta } from './parse_meta';

const HELP_CHAT_WINDOW_STATUS_LOCAL_STORAGE_KEY = 'helpChatWindowStatus';
const MINIMIZED_WINDOW_STATUS = 'minimized';
const OPEN_WINDOW_STATUS = 'open';

function loadZendeskSettings(chatDepartmentId, tags) {
  window.zESettings = {
    webWidget: {
      chat: {
        tags,
        departments: {
          enabled: [],
          select: chatDepartmentId,
        },
        prechatForm: {
          greeting: {
            '*': I18n.t('zendesk.zopim.prechatForm.greetings'),
          },
        },
        title: {
          '*': I18n.t('zendesk.zopim.window.title'),
        },
      },
      color: {
        bypassAccessibilityRequirement: true,
      },
      helpCenter: {
        chatButton: {
          '*': I18n.t('zendesk.webWidget.helpCenter.chatButton'),
        },
        title: {
          '*': I18n.t('zendesk.webWidget.helpCenter.title'),
        },
        searchPlaceholder: {
          '*': I18n.t('zendesk.webWidget.helpCenter.searchPlaceholder'),
        },
      },
      launcher: {
        chatLabel: {
          '*': I18n.t('zendesk.webWidget.launcher.chatLabel'),
        },
        label: {
          '*': I18n.t('zendesk.webWidget.launcher.label'),
        },
      },
      contactOptions: {
        contactButton: {
          '*': I18n.t('zendesk.webWidget.contactOptions.contactButton'),
        },
      },
    },
  };
}

function getChatWindowStatusFromLocalStorage() {
  try {
    return localStorage.getItem(HELP_CHAT_WINDOW_STATUS_LOCAL_STORAGE_KEY);
  } catch (e) {
    console.log(e);
  }

  return null;
}

export function hasPersistedOpenChat() {
  const windowStatusFromLocalStorage = getChatWindowStatusFromLocalStorage();

  return windowStatusFromLocalStorage === OPEN_WINDOW_STATUS;
}

function setChatWindowStatus(newStatus) {
  try {
    if (newStatus) {
      localStorage.setItem(HELP_CHAT_WINDOW_STATUS_LOCAL_STORAGE_KEY, newStatus);
    } else {
      localStorage.removeItem(HELP_CHAT_WINDOW_STATUS_LOCAL_STORAGE_KEY);
    }
  } catch (e) {
    console.log(e);
  }
}

function loadWidget(key) {
  const el = document.createElement('script');
  el.id = 'ze-snippet';
  el.type = 'text/javascript';
  el.async = true;
  el.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;
  document.body.appendChild(el);

  return new Promise((res, rej) => {
    el.onload = res;
    el.onerror = rej;
  });
}

function getWidgetConfig() {
  // set in _zendesk_embed.haml.
  // this should probably be moved into common state like UserContext

  return window.__zendeskWidgetConfig;
}

/**
 * Opens the Zendesk widget. Must be called after `loadZendeskEmbed` resolves
 */
export function openWidget() {
  window.zE('webWidget', 'open');
}

export function loadZendeskEmbed() {
  if (!ZENDESK_WIDGET_KEY) {
    return Promise.reject('ZENDESK_WIDGET_KEY is unset, not loading');
  }

  const config = getWidgetConfig();
  loadZendeskSettings(config.chatDepartmentId, config.tags);

  return loadWidget(ZENDESK_WIDGET_KEY).then(() => {
    // set widget locale
    window.zE('webWidget', 'setLocale', config.zendeskAllowedLocale);

    // set search suggestions
    window.zE('webWidget', 'helpCenter:setSuggestions', {
      labels: config.searchLabels,
    });

    const currentUser = parseMeta('current-user');
    if (currentUser.user.name) {
      window.zE('webWidget', 'prefill', {
        name: { value: currentUser.user.name, readOnly: false },
        email: { value: currentUser.user.email, readOnly: false },
      });
    }

    window.zE('webWidget:on', 'close', () => {
      setChatWindowStatus(MINIMIZED_WINDOW_STATUS);
    });

    window.zE('webWidget:on', 'chat:end', () => {
      setChatWindowStatus();
    });

    window.zE('webWidget:on', 'chat:start', () => {
      setChatWindowStatus(OPEN_WINDOW_STATUS);
    });

    return new Promise((res) => {
      window.zE('webWidget:on', 'chat:connected', res);
    });
  });
}



// WEBPACK FOOTER //
// ./javascripts/components/zendesk.js